export default {
  heading: `'Libre Franklin', -apple-system, system-ui, sans-serif`,
  body: `'Libre Franklin', -apple-system, system-ui, sans-serif`,
};
